export { NewEventDetailAttendeesList } from "./NewEventDetailAttendeesList";
